<template>
  <div class="MapModal" role="dialog" aria-modal="true" @keydown.esc="close">
    <div class="MapModal__mask" @click="close"></div>

    <div class="MapModal__panel" ref="panel" role="document">
      <button class="MapModal__close" type="button" aria-label="Fermer" @click="close">✕</button>

      <div class="MapModal__header" v-if="title || address">
        <h3 class="MapModal__title" v-if="title">{{ title }}</h3>
        <p class="MapModal__addr" v-if="address">{{ address }}</p>
      </div>

      <!-- ✅ Same API as your example -->
      <mapbox
        ref="mb"
        :access-token="accessToken"
        :map-options="{
          style: styleUrl,
          zoom,
          center,
          dragPan: true,
          scrollZoom: true,
          doubleClickZoom: true,
          keyboard: true,
          touchZoomRotate: true
        }"
        @map-init="onMapLoad"
      />
    </div>
  </div>
</template>

<script>
import 'mapbox-gl/dist/mapbox-gl.css'
import Mapbox from 'mapbox-gl-vue';

// Import mapboxgl globally for marker creation
window.mapboxgl = mapboxgl

export default {
  name: 'MapboxModal',
  components: { Mapbox },
  props: {
    accessToken: { type: String, required: true },
    center: { type: Array, default: () => [2.2137, 46.2276] },
    marker: { type: Boolean, default: true },
    title: { type: String, default: '' },
    address: { type: String, default: '' },
    zoom: { type: Number, default: 4 },
    styleUrl: { type: String, default: 'mapbox://styles/mapbox/streets-v10' }
  },
  data () {
    return { map: null, markerInstance: null }
  },
  mounted () {
    // lock scroll + focus panel
    document.body.style.overflow = 'hidden'
    this.$nextTick(() => this.$refs.panel?.focus?.())
  },
  beforeDestroy () {
    try { this.markerInstance?.remove() } catch (e) {}
    try { this.map?.remove() } catch (e) {}
    document.body.style.overflow = ''
  },
  methods: {
    onMapLoad (map) {
      this.map = map

      map.setCenter([2.2137, 46.2276])
      map.setZoom(this.zoom)
      
      if (this.marker) {
        // Create custom marker element
        let el = document.createElement('div')
        el.className = 'mapbox-modal-marker'
        
        let img = document.createElement('img')
        img.src = 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/address_books/lodge_building.png'
        img.style.width = '30px'
        img.style.height = '30px'
        el.appendChild(img)

        this.$nextTick(() => {
          this.markerInstance = new mapboxgl.Marker(el)
            .setLngLat([this.center[1], this.center[0]])
            .addTo(map)
        }, 500);
      }

      // ensure size is correct if modal animated
      setTimeout(() => map.resize(), 150)
    },
    close () { this.$emit('close') }
  }
}
</script>

<style>
.MapModal { position: fixed; inset: 0; z-index: 9999; }
.MapModal__mask { position:absolute; inset:0; background: rgba(0,0,0,0.45); }
.MapModal__panel {
  position:absolute; inset: 5% 4%;
  background: #ffffff; border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.22);
  display: grid; grid-template-rows: auto 1fr; outline: none;
}
.MapModal__close {
  position:absolute; top: 10px; right: 12px;
  width: 40px; height: 40px; border: 0; border-radius: 9999px;
  font-size: 22px; line-height: 40px; cursor: pointer;
  background: #f2f2f2; color:#111111;
}
.MapModal__header { padding: 16px 18px 8px 18px; }
.MapModal__title {
  margin: 0 42px 4px 0; font-weight: 800; color:#0d0d0d; font-family: 'Raleway', Arial, sans-serif;
}
.MapModal__addr { margin:0; color:#2d5f49; font-weight: 600; font-family: 'Raleway', Arial, sans-serif; }

/* The <mapbox> root takes available height; make the panel map fill it */
.MapModal .mapboxgl-map { width: 100%; height: calc(100% - 76px); border-radius: 0 0 16px 16px; overflow:hidden; }

/* Custom marker styling */
.mapbox-modal-marker {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mapbox-modal-marker img {
  transition: transform 0.2s ease;
}

.mapbox-modal-marker:hover img {
  transform: scale(1.1);
}

@media (max-width: 720px){
  .MapModal__panel { inset: 6% 3%; }
  .MapModal .mapboxgl-map { height: calc(100% - 68px); }
}
</style>